import React from 'react';
import { Box } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid';
import { AdminBrokerGroupPicker } from '@/admin/shared/pickers/AdminBrokerGroupPicker';

/** Edits a row's primary broker group (AdminBrokerGroupPicker). Picking one saves the cell. */
export const PrimaryBrokerGroupEditCell = ({ id, field, value }) => {
	const apiRef = useGridApiContext();

	const handleChange = async (brokerGroupId) => {
		await apiRef.current.setEditCellValue({ id, field, value: brokerGroupId });
		apiRef.current.stopCellEditMode({ id, field });
	};

	return (
		<Box sx={{ width: '100%', px: 0.5 }}>
			<AdminBrokerGroupPicker multiple={false} value={value} onChange={handleChange} />
		</Box>
	);
};
